export enum CreateCoursePermission {
  NOT_ALLOWED,
  ALLOWED,
  PROVISIONAL,
}
